export const ONBOARDING_ROLES = {
  PLUGIN_ADMIN: 'plugin-admin',
  WORKSPACE_ADMIN: 'workspace-admin',
  USER: 'user'
}
